import { Info } from '@ui/components/icons';
import { TooltipWithTouch } from '@ui/components/TooltipWithTouch';
import { Portal } from '@ui/lib/park/portal';
import { Icon } from '@ui/lib/park/ui/icon';
import { Text } from '@ui/lib/park/ui/text';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { HStack, HstackProps } from 'styled-system/jsx';

export const MarketHourCloseIndicator = ({
  isOrder,
  ...props
}: {
  isOrder?: boolean;
} & HstackProps) => {
  const { t } = useTranslation();

  return (
    <HStack gap={1} {...props}>
      <MarketCloseTooltip isOrder={isOrder}>
        <Text textStyle="text.xsmall" color="system.system">
          {t('common.Market Closed')}

          <Icon boxSize="10px" ml={1}>
            <Info />
          </Icon>
        </Text>
      </MarketCloseTooltip>
    </HStack>
  );
};

const MarketCloseTooltip = ({
  isOrder,
  children,
}: {
  isOrder?: boolean;
  children: ReactNode;
}) => {
  const { t } = useTranslation();

  return (
    <TooltipWithTouch.Root
      variant="darkBox"
      positioning={{
        placement: 'top',
      }}
    >
      <TooltipWithTouch.Trigger asChild>{children}</TooltipWithTouch.Trigger>
      <Portal>
        <TooltipWithTouch.Positioner>
          <TooltipWithTouch.Content maxW="56">
            <TooltipWithTouch.Arrow>
              <TooltipWithTouch.ArrowTip />
            </TooltipWithTouch.Arrow>
            <Text>
              {/* FIXME: pair specific  */}
              {isOrder
                ? t(
                    'common.Positions cannot be opened after market hours. You can still cancel your order or edit your TP/SL',
                  )
                : t(
                    'common.Positions cannot be opened or closed during off-hours. You can still manage collateral and edit your SL/TP orders.',
                  )}
            </Text>
          </TooltipWithTouch.Content>
        </TooltipWithTouch.Positioner>
      </Portal>
    </TooltipWithTouch.Root>
  );
};
